import { useContext } from "react";
import {DriveContext} from "../providers/DriveProvider";

export default function useDrive() {
    const {
        CurrentDrive, changeCurrentDrive,
        renameRow, changeRenameRow,
        renameFolder, changeRenameFolder,
        copyPath, setCopyPath,
        uploadStatus, changeUploadStatus,
        deleteKey, changeDeleteKey,
        selectedRow, changeSelectedRow,
        previewObject, changePreviewObject,
        editorObject, changeEditorObject,
        uploadProgress, changeUploadProgress,
        layout, changeLayout,
    } = useContext(DriveContext);
    return {
        CurrentDrive, changeCurrentDrive,
        renameRow, changeRenameRow,
        renameFolder, changeRenameFolder,
        copyPath, setCopyPath,
        uploadStatus, changeUploadStatus,
        deleteKey, changeDeleteKey,
        selectedRow, changeSelectedRow,
        previewObject, changePreviewObject,
        editorObject, changeEditorObject,
        uploadProgress, changeUploadProgress,
        layout, changeLayout,
    };
}